import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { RankDifficulty, PagedResponseRankDifficulty } from '../models/RankDifficulty';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class RankDifficultyService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getRankDifficulties():Observable<PagedResponseRankDifficulty>{
    const data =  this.http.get<PagedResponseRankDifficulty>(this.APIURL+'/RankDifficulty' + '?PageNumber=1&PageSize=100');
    this.messageService.add('RankDifficulty Service: fetched RankDifficulties');
    return data;
  }

  getRankDifficulty(id: number): Observable<RankDifficulty> {
        const RankDifficulty =this.http.get<RankDifficulty>(this.APIURL+'/RankDifficulty/' + id);
    this.messageService.add(`RankDifficulty Service: fetched RankDifficulty with id=${id}`);
    return RankDifficulty;
  }
}